module.exports = __webpack_public_path__ + "static/media/desk.1f098ec4.svg";